import { Component,  Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { ModalResponse } from '../../../models/modal-response';

export interface DeleteManualSignatureModalData {
  id: string;
  gifLoader: boolean;
}


@Component( {
  selector: 'delete-manual-signature-modal',
  templateUrl: './delete-manual-signature-modal.component.html',
  styleUrls: [ './delete-manual-signature-modal.component.scss' ],
  imports: [
    TranslateModule,
    MatDialogModule,
    NgIf
  ],
  standalone: true
})
export class DeleteManualSignatureModalComponent implements OnInit {

  ModalResponse = ModalResponse;
  loading: boolean;
  constructor(
    public dialogRef: MatDialogRef<DeleteManualSignatureModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteManualSignatureModalData
  ) {
  }

  ngOnInit() {
    console.log(this.data);
  }

  closeDialog(response: ModalResponse) {
    this.dialogRef.close(response);
  }

}
